export async function startCamera(video: HTMLVideoElement): Promise<void> {
  const stream = await navigator.mediaDevices.getUserMedia({
    video: {
      facingMode: { ideal: 'environment' },
      width: { ideal: 1280 },
      height: { ideal: 720 },
    },
    audio: false,
  });
  video.srcObject = stream;
  await video.play();
  await new Promise<void>((resolve) => {
    if (video.readyState >= 2) {
      resolve();
      return;
    }
    video.addEventListener('loadeddata', () => resolve(), { once: true });
  });
}

export async function grabFrame(
  video: HTMLVideoElement,
  targetLongSide: number,
): Promise<ImageBitmap | null> {
  if (!video.videoWidth || !video.videoHeight) return null;
  if (targetLongSide <= 0) {
    return await createImageBitmap(video);
  }
  const scale = Math.min(1, targetLongSide / Math.max(video.videoWidth, video.videoHeight));
  const w = Math.round(video.videoWidth * scale);
  const h = Math.round(video.videoHeight * scale);
  return await createImageBitmap(video, 0, 0, video.videoWidth, video.videoHeight, {
    resizeWidth: w,
    resizeHeight: h,
    resizeQuality: 'medium',
  });
}
